import React, { Component } from "react";
import { Route, Switch } from "react-router";
import styles from "./../content.module.scss";
import WinterMaintenceBar from "../../sections/sideBars/WinterMaintenceBar";
import WinterMaintenceMapWrapper from "./WinterMaintenceMapWrapper";

class WinterMaintenceContent extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route exact path={["/winter/maintenance"]}>
            <div className={this.props.isSideBarOpen ? styles.content : styles.content_closedBar}>
              <div className={styles.container_sideBar}>
                <Switch>
                  <Route exact path={["/winter/maintenance"]} component={WinterMaintenceBar} />
                </Switch>
              </div>
              <div className={styles.container_sideContent}>
                <Switch>
                  <Route exact path={["/winter/maintenance"]} component={WinterMaintenceMapWrapper} />
                </Switch>
              </div>
            </div>
          </Route>
        </Switch>
      </div>
    );
  }
}

export default React.memo(WinterMaintenceContent);
